<ng-container *ngFor="let alternative of currentStep?.stepAlternatives | sortByLineNumber; last as isLastAlternative">
  <ng-container *ngFor="let item of alternative?.items; last as isLast">
  <fts-special-wizard-item-selector-entry
    [item]='item'
    [currentStep]='currentStep'
    (itemSelected)='onItemSelected($event)'
  ></fts-special-wizard-item-selector-entry>
  <hr *ngIf='!(isLast && isLastAlternative)' class='no-margin' aria-hidden="true">
  </ng-container>
</ng-container>

